import { apiService } from '@/services/APIService';

import { rHandler } from '@/plugins/RHandler';

import { objectsRHandler, DEFAULT_PARAMS } from '@/utils/objectsRHandler';

import AdminEventTemplate from '../list/admin-event-template';
import AdminEventTemplateTag from '../list/admin-event-template-tag';

const API_PATH = 'admin-event-templates';
const API_PATH_TAGS = 'admin-event-template-tags';
const API_PATH_GROUPS = 'admin-event-template-groups';

const tagsRHandler = (url, Model) => ({
  ...objectsRHandler(url, Model),
  // {
  //   "template_ids": [1,2],
  //   "tag_ids": [1,4,6] ("group_ids": [1,3])
  // }
  attach({ data } = DEFAULT_PARAMS) {
    return rHandler(
      apiService.post(`${url}/attach-template`, data),
      (response) => ({
        response,
        items: response.data.data.map((i) => new Model(i, url)),
      }),
      (error) => ({ error }),
    );
  },
  detach({ data } = DEFAULT_PARAMS) {
    return rHandler(
      apiService.post(`${url}/detach-template`, data),
      (response) => ({
        response,
        items: response.data.data.map((i) => new Model(i, url)),
      }),
      (error) => ({ error }),
    );
  },
});

export const AdminEventTemplatesManager = {
  objects: objectsRHandler(API_PATH, AdminEventTemplate),
  tags: tagsRHandler(API_PATH_TAGS, AdminEventTemplateTag),
  groups: tagsRHandler(API_PATH_GROUPS, AdminEventTemplateTag),
};
